import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from './Icon';

// `full` is for working surfaces (the campaign wizard, the template editor): almost the
// whole viewport, so a vendor list or a 600px email fits without inner scrollbars.
const SIZES = { md: 'max-w-lg', lg: 'max-w-3xl', xl: 'max-w-5xl', full: 'max-w-[min(1520px,96vw)]' };

/**
 * Centered modal. Ported from D:\campaigning-system\src\components\ui\Modal.tsx.
 * Portals to document.body, wrapped in a background-less `.campaign-os` scope so the glass-card
 * panel + Hanken font resolve outside the shell.
 */
export function Modal({ open, onClose, children, size = 'lg', labelledBy }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;
  return createPortal(
    <div className="campaign-os" style={{ background: 'none', minHeight: 0 }}>
      <div className="fixed inset-0 z-[60] flex items-start justify-center overflow-y-auto p-4 sm:p-6">
        <div className="fixed inset-0 bg-[rgba(35,40,36,0.28)] backdrop-blur-[3px] animate-fade-in" onClick={onClose} />
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby={labelledBy}
          className={`glass-card relative z-10 my-4 w-full ${SIZES[size]} animate-scale-in p-0`}
        >
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}

export function ModalClose({ onClose }) {
  return (
    <button
      onClick={onClose}
      aria-label="Close"
      className="grid h-9 w-9 place-items-center rounded-lg text-cos-ink-muted transition-colors hover:bg-white/70 hover:text-cos-ink"
    >
      <Icon name="close" className="text-[20px]" />
    </button>
  );
}

export default Modal;
